module.exports = __webpack_public_path__ + "img/scholarship-example-mobile.af6b443.png";